import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-expiration-session',
  templateUrl: './expiration-session.component.html',
  styleUrls: ['./expiration-session.component.scss']
})
export class ExpirationSessionComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  reconnexion(){
    this.activeModal.close(true);
  }
}
